import React from "react";
import AccordionList from "../VideoCall/ActionPanel/AccordionList";
import { TEST_CONSULTATION_DATA } from "../../../utils/testVirtualGuard";

const noop = () => {};
const stompStub = { send: noop };

// Virtual guard action panel without a video call, laid out as in the real
// screen once the patient has finished. Sending the consultation is disabled.
const TestVirtualGuard = () => (
  <div>
    <p style={{ margin: "10px" }}>
      Modo prueba: no se envía la consulta ni se registra la historia clínica.
    </p>
    <div className="videocall">
      <div className="container" style={{ display: "inline-block" }}>
        <div style={{ height: "80vh" }}>
          <div className="action-panel" style={{ height: "100%" }}>
            <AccordionList
              testMode
              consultationData={TEST_CONSULTATION_DATA}
              stomp={stompStub}
              setConsultIsSubmitted={noop}
              setConsultFinishedWithError={noop}
              setMessage={noop}
              setPatientLeftProfessionalContainerStyle={noop}
              setContainerStyle={noop}
              setPatientFinish={noop}
              patientFinish
            />
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default TestVirtualGuard;
